<!--Announcements Display-->
@if (
  (loggedInAnnouncements && (loggedInAnnouncements | keyvalue).length) ||
  (invokedAnnouncements && (invokedAnnouncements | keyvalue).length) ||
  (isTravelAdvice && travelAdvice)
) {
  <div
    class="announcement_dropdown_container"
    id="announcement_container"
    #announcementDropdown
    role="region"
    aria-label="User announcements and messages"
    aria-live="polite"
    [ngClass]="{
      announcements_closed: !open && !loggedInUserOpen && !invokedUserOpen,
      split_view: invokedUser
    }"
  >
    <!-- No invoked user: Single banner (original behavior) -->
    @if (!invokedUser && userData) {
      <div
        class="user-container"
        role="article"
        [attr.aria-labelledby]="'user-banner-heading-' + userData?.id"
      >
        <div class="user-banner-content">
          <app-user-banner-header
            [title]="userData?.title"
            [forename]="userData?.forename"
            [surname]="userData?.surname"
          >
          </app-user-banner-header>
          @if (loggedInUserOpen) {
            <div class="user-banner-body">
              @if (isTravelAdvice) {
                <app-travel-advice [travelAdvice]="travelAdvice"></app-travel-advice>
              }
              <app-announcement-list
                [announcements]="loggedInAnnouncements"
                [showTravelAdviceCondition]="isTravelAdvice && travelAdvice"
                checkboxId="suppress_announcement"
                (deleteAnnouncementEvent)="deleteAnnouncement($event)"
                (suppressAnnouncementEvent)="suppressAnnouncement($event)"
              >
              </app-announcement-list>
            </div>
          }
        </div>
        <button
          class="small-button collapse-button"
          [attr.aria-expanded]="loggedInUserOpen"
          [attr.aria-label]="
            loggedInUserOpen
              ? 'Hide messages for ' +
                userData?.title +
                ' ' +
                userData?.forename +
                ' ' +
                userData?.surname
              : 'Show messages for ' +
                userData?.title +
                ' ' +
                userData?.forename +
                ' ' +
                userData?.surname
          "
          (click)="loggedInUserOpen = !loggedInUserOpen"
        >
          @if (loggedInUserOpen) {
            <span i18n="@@searchToggleState_hide">Hide</span>
          }
          @if (!loggedInUserOpen) {
            <span i18n="@@searchToggleState_show">Show</span>
          }
        </button>
      </div>
    }

    <!-- Invoked user present: Split banner -->
    @if (invokedUser && userData) {
      <div class="split-banner-container">
        <!-- Left: Logged-in user section -->
        <div
          class="logged-in-user-section"
          role="article"
          [attr.aria-label]="
            'Messages for ' + userData?.title + ' ' + userData?.forename + ' ' + userData?.surname
          "
          [ngClass]="{ collapsed: !loggedInUserOpen, 'user-container': loggedInUserOpen }"
        >
          @if (!loggedInUserOpen) {
            <!-- Collapsed state: Clickable text -->
            <button
              class="view-logged-in-messages-btn"
              [attr.aria-label]="
                'View messages for ' +
                userData?.title +
                ' ' +
                userData?.forename +
                ' ' +
                userData?.surname
              "
              (click)="toggleLoggedInUserSection()"
            >
              Click to view messages for {{ userData?.title }}. {{ userData?.forename }}
              {{ userData?.surname }}
            </button>
          }

          @if (loggedInUserOpen) {
            <!-- Expanded state: Full banner -->
            <div class="user-banner-content">
              <app-user-banner-header
                [title]="userData?.title"
                [forename]="userData?.forename"
                [surname]="userData?.surname"
                [showCollapseButton]="true"
                (collapseClick)="toggleLoggedInUserSection()"
              >
              </app-user-banner-header>
              <div class="user-banner-body">
                <app-announcement-list
                  [announcements]="loggedInAnnouncements"
                  [showTravelAdviceCondition]="isTravelAdvice && travelAdvice"
                  checkboxId="suppress_announcement_logged_in"
                  (deleteAnnouncementEvent)="deleteAnnouncement($event)"
                  (suppressAnnouncementEvent)="suppressAnnouncement($event)"
                >
                </app-announcement-list>
              </div>
            </div>
            <button
              class="small-button collapse_messages-user"
              [attr.aria-expanded]="loggedInUserOpen"
              [attr.aria-label]="
                'Hide messages for ' +
                userData?.title +
                ' ' +
                userData?.forename +
                ' ' +
                userData?.surname
              "
              (click)="loggedInUserOpen = !loggedInUserOpen"
            >
              <fa-icon [icon]="faCaretLeft" aria-hidden="true"></fa-icon>
            </button>
          }
        </div>

        <!-- Right: Invoked user section -->
        <div
          class="user-container"
          role="article"
          [attr.aria-label]="
            'Messages for ' +
            invokedUser?.title +
            ' ' +
            invokedUser?.forename +
            ' ' +
            invokedUser?.surname
          "
        >
          <div class="user-banner-content">
            <app-user-banner-header
              [title]="invokedUser?.title"
              [forename]="invokedUser?.forename"
              [surname]="invokedUser?.surname"
              [showDoubleIcon]="true"
            >
            </app-user-banner-header>
            @if (invokedUserOpen) {
              <div class="user-banner-body">
                @if (isTravelAdvice) {
                  <app-travel-advice [travelAdvice]="travelAdvice"></app-travel-advice>
                }
                <app-announcement-list
                  [announcements]="invokedAnnouncements"
                  [showTravelAdviceCondition]="isTravelAdvice && travelAdvice"
                  checkboxId="suppress_announcement_invoked"
                  (deleteAnnouncementEvent)="deleteAnnouncement($event)"
                  (suppressAnnouncementEvent)="suppressAnnouncement($event)"
                >
                </app-announcement-list>
              </div>
            }
          </div>
          <button
            class="small-button collapse-button"
            [attr.aria-expanded]="invokedUserOpen"
            [attr.aria-label]="
              invokedUserOpen
                ? 'Hide messages for ' +
                  invokedUser?.title +
                  ' ' +
                  invokedUser?.forename +
                  ' ' +
                  invokedUser?.surname
                : 'Show messages for ' +
                  invokedUser?.title +
                  ' ' +
                  invokedUser?.forename +
                  ' ' +
                  invokedUser?.surname
            "
            (click)="toggleInvokedUserSection()"
          >
            @if (invokedUserOpen) {
              <span i18n="@@searchToggleState_hide" aria-hidden="true">Hide</span>
            }
            @if (!invokedUserOpen) {
              <span i18n="@@searchToggleState_show" aria-hidden="true">Show</span>
            }
          </button>
        </div>
      </div>
    }
  </div>
}
